import LinkVariant from "../link/@types/LinkVariant";
import { Link } from "../link";

import styles from "./rlcard.module.scss";

type RLCardHeaderLinkProps = React.ComponentProps<typeof Link> & {
  variant?: LinkVariant;
};

const RLCardHeaderLink: React.FC<RLCardHeaderLinkProps> = ({
  variant = "navigation",
  children,
  ...otherProps
}) => (
  <Link variant={variant} {...otherProps} className={styles.header_link}>
    {children}
  </Link>
);

export default RLCardHeaderLink;
